import React from "react"
import {TableRow} from "./TableRow"

export function TableBody({
  data,
  expandedRow,
  selected,
  handleBrandRowClick,
  handleCategoryRowClick,
}) {
  let allItemRows = []
  const renderRow = (category) => {
    const itemRows = [
      <TableRow
        key={category.sicCode}
        type={"category"}
        handleClick={handleCategoryRowClick}
        expandedRow={expandedRow}
        rowId={category.sicCode}
        selected={selected}
        data={category}
      />,
    ]
    if (expandedRow === category.sicCode && category.brands) {
      category.brands.forEach((brand) => {
        itemRows.push(
          <TableRow
            key={brand.id}
            type={"brand"}
            handleClick={handleBrandRowClick}
            expandedRow={expandedRow}
            rowId={brand.id}
            selected={selected}
            data={brand}
          />
        )
      })
    }
    return itemRows
  }
  data.forEach((item) => {
    let perItemRows = renderRow(item)
    allItemRows = allItemRows.concat(perItemRows)
  })
  return (
    <tbody className="hovered" data-testid="tbody">
      {allItemRows}
    </tbody>
  )
}
